import { colors, FelaCSS } from '@bridebook/ui';

interface IStyles {
  date: FelaCSS;
  dateWrap: FelaCSS;
  fairHeading: FelaCSS;
  infoWrap: FelaCSS;
  text: FelaCSS;
  wrapper: FelaCSS;
}

const styles: IStyles = {
  date: {
    fontDefaultSemiBold: 12,
    lineHeight: '14px',
  },
  dateWrap: {
    flexShrink: 0,
    marginLeft: '14px',
    paddingBottom: '1px',
    paddingTop: '1px',
  },
  fairHeading: {
    color: colors.space,
    fontDefaultSemiBold: 16,
    lineHeight: '20px',
    marginBottom: '0',
    marginTop: '0',
    wordBreak: 'break-word',
  },
  infoWrap: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  text: {
    color: colors.space75,
    fontDefault: 14,
    lineHeight: '16px',
    wordBreak: 'break-word',
  },
  wrapper: {
    ':not(:last-of-type)': {
      marginBottom: '16px',
    },
  },
};

export default styles;
